import React, { useEffect, useState } from 'react';
import AtmLocator from '../../AtmLocator';
import ServiceOfferingsLabels from '../ServiceOfferingsLabels';
import styles from "./LocatorService.module.css";
import leftArrow from "../../../assets/images/arrow-left-svg.svg"
import AtmLocatorIcon from '../../../assets/icons/AtmLocatorIcon';
import BranchLocatorIcon from '../../../assets/icons/BranchLocatorIcon';
import LiveChatIcon from '../../../assets/icons/LiveChatIcon';

function LocatorServices(props) {

    const [isOpen, setIsOpen] = useState(props.showSidepanel);
    const [locatorType, setLocatorType] = useState('')
    const [showLocator, setShowLocator] = useState(false)

    const openLocatorSidePanel = (type: string) => {
        setShowLocator(true)
        setLocatorType(type)
        handleToggle(true)
    }

    const handleToggle = (value?:boolean) => {
        setIsOpen(!isOpen);
        if(!value){
            setShowLocator(false)
        }
    };

    return (
        <div>
            <div className={styles.main}>
                <div className={styles.customerFlex}>
                    <div
                        className={styles.locatorLabel}
                        onClick={() => openLocatorSidePanel('ATM')}
                    >
                        <ServiceOfferingsLabels
                            headerText="ATM Locator"
                            icon={<AtmLocatorIcon/>}
                        />
                    </div>
                    <div
                        className={styles.locatorLabel}
                        onClick={() => openLocatorSidePanel('Branch')}
                    >
                        <ServiceOfferingsLabels
                            headerText="Branch Locator"
                            icon={<BranchLocatorIcon/>}
                        />
                    </div>
                    <div>
                        <ServiceOfferingsLabels
                            headerText="Live chat"
                            icon={<LiveChatIcon/>}
                            // locatorSubText="Coming soon"
                        />
                    </div>
                </div>
            </div>

            {
                showLocator &&
                <div>
                    <div className={`${styles.sidePanel} ${isOpen ? styles.open : ''}`}>
                        <div className='d-flex justify-content-between align-items-center'>
                            <img src={leftArrow} onClick={() => handleToggle(false)} className="cursor-pointer mb-2"/>
                            <h4>{locatorType} locator</h4>
                        </div>
                        <AtmLocator type={locatorType}/>
                    </div>
                </div>
            }
        </div>
    );
}

export default LocatorServices;